export default function(ctx) {
var __t, __p = '';
__p += '<div ref="addressNLContainer"></div>\n';
return __p
}